import sortPeopleByName from '../../util/sort_people_by_name'

const MemberManager = function ($scope) {
  const $ctrl = this;

  $ctrl.$onChanges = function () {
    sortPeople();
  };

  $ctrl.userClickedMoveIn = function () {
    let updatedMembers = angular.copy($ctrl.members);

    $ctrl.selectedNonMembers.forEach(nonMemberId => {
      let newMember = $ctrl.nonMembers.find(person => person.id == nonMemberId);
      if (newMember) {
        updatedMembers.push(newMember);
      }
    });

    requestMembershipChange(updatedMembers);
  };

  $ctrl.userClickedMoveOut = function () {
    let updatedMembers = angular.copy($ctrl.members);

    $ctrl.selectedMembers.forEach(memberId => {
      let formerMember = updatedMembers.find(person => person.id == memberId);
      updatedMembers.splice(updatedMembers.indexOf(formerMember), 1);
    });

    requestMembershipChange(updatedMembers);
  };

  function requestMembershipChange(updatedMembers) {
    $ctrl.selectedNonMembers = null;
    $ctrl.selectedMembers = null;
    $ctrl.requestChangeToList({updatedMemberList: updatedMembers}).then(() => {
      sortPeople();
      $scope.$digest();
    });
  }

  function sortPeople() {
    $ctrl.members.sort(sortPeopleByName);
    $ctrl.nonMembers.sort(sortPeopleByName);
  }

};

export default {
  name: 'memberManager',
  obj: {
    controller: MemberManager,
    templateUrl: 'components/member_manager.html',
    bindings: {
      members: '<',
      nonMembers: '<',
      requestChangeToList: '&'
    }
  },
  deps: []
};